// Date/time formatting helpers.
// Backend datetimes are naive UTC — parseUTC appends Z so the browser converts
// them to the viewer's local timezone. All times are shown in 12-hour AM/PM.

const DATE_OPTS = { day: '2-digit', month: '2-digit', year: 'numeric' };
const TIME_OPTS = { hour: 'numeric', minute: '2-digit', hour12: true };

export function parseUTC(str) {
  if (!str) return null;
  const s = String(str);
  const withZone = s.endsWith('Z') || s.includes('+') ? s : s + 'Z';
  const d = new Date(withZone);
  return isNaN(d.getTime()) ? null : d;
}

// "17/07/2026, 2:00 PM"  (or just the date when dateOnly)
export function fmtDate(str, dateOnly = false) {
  const d = parseUTC(str);
  if (!d) return '—';
  const datePart = d.toLocaleDateString([], DATE_OPTS);
  return dateOnly ? datePart : `${datePart}, ${d.toLocaleTimeString([], TIME_OPTS)}`;
}

// "2:00 PM"
export function fmtTime(str) {
  const d = parseUTC(str);
  return d ? d.toLocaleTimeString([], TIME_OPTS) : '—';
}

export function fmtDateRange(start, end) {
  return `${fmtDate(start, true)} – ${fmtDate(end, true)}`;
}
